import { render, staticRenderFns } from "./OldRack.vue?vue&type=template&id=f5b9dcba&scoped=true&"
import script from "./OldRack.vue?vue&type=script&lang=js&"
export * from "./OldRack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b9dcba",
  null
  
)

export default component.exports